import { Link } from 'react-router-dom';

export default function WhatIs() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-3">
              About the Resource
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              What Is Vigorbuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>
                <strong className="text-foreground-900">Vigorbuy Spreadsheet</strong> is an organized product research system that helps shoppers discover products faster through categorized lists, product information, comparison data, and shopping guides.
              </p>
              <p>
                Instead of searching through thousands of products manually, users can use structured spreadsheets to compare options and make better decisions. The system organizes products by categories such as Shoes, Hoodies, T-Shirts, Jackets, and many more, allowing for efficient browsing and research.
              </p>
              <p>
                Whether you are a first-time shopper or an experienced product researcher, <strong className="text-foreground-900">Vigorbuy Spreadsheet</strong> provides the tools and information you need to shop smarter. Our platform aggregates product data across multiple categories, making it easier than ever to find exactly what you are looking for.
              </p>
            </div>
            <div className="mt-6">
              <Link
                to="/vigorbuy-spreadsheet-beginner-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line"></i>
                Read the Full Guide
              </Link>
            </div>
          </div>

          <div className="flex-shrink-0 w-full lg:w-[420px] h-[320px] md:h-[380px] rounded-2xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Detailed%20product%20comparison%20workspace%20featuring%20an%20open%20notebook%20alongside%20fashion%20items%20on%20warm%20oak%20desk%20surface%2C%20soft%20morning%20light%20casting%20gentle%20shadows%2C%20analog%20research%20concept%20with%20handwritten%20notes%20and%20product%20samples%2C%20warm%20terracotta%20and%20cream%20color%20palette%2C%20clean%20minimalist%20workspace%20photography%2C%20organized%20shopping%20research%20concept%20with%20coffee%20cup%20and%20fabric%20swatches&width=840&height=760&seq=vigorbuy-whatis-03&orientation=portrait"
              alt="Vigorbuy Spreadsheet product catalog concept - organized shopping guide with fashion items and labels"
              title="Vigorbuy Spreadsheet - Organized Shopping Resource"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}